import React from "react";

export default function NoRecords() {
  return (
    <div
      style={{
        justifyContent:'center', alignItems:'center', textAlign:'center',
        width: "100%",
      }}
    >
      <img src="/images/no_records.png" width="200px" />
    </div>
  );
}
